// Static routes must never receive a game address that would be shadowed by the router.
export const reservedRootSegments: readonly string[] = [
  ".well-known",
  "_marketing",
  "_web",
  "about",
  "account",
  "admin",
  "agents.md",
  "alb",
  "alignmentleague",
  "atlas",
  "api",
  "beltholder",
  "blog",
  "browse",
  "browseall",
  "campaign-board",
  "cli-auth",
  "cogames",
  "cogent.md",
  "complete-profile",
  "contact",
  "coworld-growth",
  "coworlds",
  "docs",
  "events",
  "episodes",
  "episode-requests",
  "experience-requests",
  "forum",
  "get-started",
  "github",
  "generals-competition",
  "ide",
  "ide-final",
  "ide-mvp",
  "ide-next",
  "index.md",
  "inspiration",
  "jobs",
  "leagues",
  "llms-full.txt",
  "llms.mdx",
  "llms.txt",
  "lobby",
  "lobbies",
  "logs",
  "media",
  "mission",
  "observatory",
  "office",
  "onboarding.md",
  "opengraph-image",
  "paper",
  "paintbot-pw",
  "play",
  "play-sessions",
  "play-full.md",
  "play.md",
  "play_gameoftheweek.md",
  "players",
  "policies",
  "preview",
  "privacy",
  "privacy-policy.pdf",
  "recyclopedia",
  "replays",
  "search",
  "sign-in",
  "sitemap-product.xml",
  "sitemap-site.xml",
  "sitemap.xml",
  "start",
  "sugarscape",
  "team",
  "terms",
  "tournaments",
  "twitter-image",
  "unlisted",
  "watch",
  "wiki",
];

// These game sections cannot also name a league.
export const reservedCoworldSegments: ReadonlySet<string> = new Set([
  "arena",
  "desk",
  "episodes",
  "episode-requests",
  "forum",
  "lobbies",
  "logs",
  "opengraph-image",
  "play",
  "play-sessions",
  "replays",
  "preview",
  "reports",
  "search",
  "sitemap.xml",
  "start",
  "submit",
  "twitter-image",
  "wiki",
]);
